import { useMutation } from '@tanstack/react-query'
import { outreachApi } from '../api'

// Fire-and-forget withdrawal request — emails ops, who process the refund
// manually via Stripe. Nothing changes server-side, so no query invalidation.
export function useRequestWithdrawalMutation(startupId: string) {
  return useMutation({
    mutationFn: () => outreachApi.requestWithdrawal(startupId),
  })
}
